import React from 'react';
import {observer} from 'mobx-react';
import {t, withState, formatCurrency} from 'shared/core';
import {auth, endpoints, types} from 'main/tools';
import {Layout, EmployeeNameWithAvatar} from 'shared/components';
import {InteractiveTable, FancyFilter} from 'main/components';
import {ExpenseRequest} from 'main/stores/expenses';
import {dateFormatter} from 'shared/tools';
import ExpensesSubnav from '../../ExpensesSubnav';
import {ExpenseRequestsContainerState} from '../state';

const COLUMNS = [
  {
    header: 'expenses.expense_requests.Employee',
    render: model => <EmployeeNameWithAvatar employee={model.employee}/>,
    width: 3
  },
  {
    header: 'expenses.expense_requests.Title',
    attribute: 'title',
    sortBy: 'title',
    width: 3
  },
  {
    header: 'expenses.expense_requests.Total',
    render: model => formatCurrency('CAD', model.totalAmount),
    width: 2
  },
  {
    header: 'expenses.expense_requests.Submitted',
    render: model => dateFormatter(model.createdAt),
    sortBy: 'createdAt',
    width: 2
  },
  {
    header: 'expenses.expense_requests.Status',
    render: model => t(`expenses.expense_requests.statuses.${model.status}`),
    sortBy: 'status',
    width: 1
  }
];

const BASE_FILTERS = [
  'expense_request_status',
  'assigned_to_me',
];
const ADMIN_FILTERS = [
  'employee',
  'location',
  'department',
  'employment_status',
  'employment_type'
];

const LOCALIZATION = {
  emptyState: 'expenses.expense_requests.No requests to display',
  removeModal: {
    header: 'expenses.expense_requests.Remove expense request?',
    body: 'expenses.expense_requests.This will permanently delete the expense request and its receipts.'
  }
};

const ExpenseRequestsContainer = observer(({uiState, scope}) => {
  const FILTERS = auth.hasAccess('::MANAGE_EXPENSES') ? [...BASE_FILTERS, ...ADMIN_FILTERS] : BASE_FILTERS;

  return (
    <div>
      <ExpensesSubnav scope={scope}/>
      <Layout>
        <InteractiveTable
          saveStateToUrl
          fancyFiltersEnabled
          title={t('expenses.expense_requests.Expense Requests')}
          columns={COLUMNS}
          localization={LOCALIZATION}
          initialFilter={{assigned_to_me: true, expense_request_status: 'pending'}}
          editRoute='/expense_requests/:id/edit'
          onRemove={expenseRequest => uiState.removeExpenseRequest(expenseRequest)}
          proxy={{
            type: 'async',
            modelType: types.EXPENSES.REQUEST,
            model: ExpenseRequest,
            endpoint: endpoints.EXPENSES.REQUESTS.ALL
          }}
        >
          <FancyFilter filters={FILTERS}/>
        </InteractiveTable>
      </Layout>
    </div>
  );
});

export default withState(ExpenseRequestsContainer, ExpenseRequestsContainerState);
